import { useNavbar, ViewNameTranslation } from "~/hooks/useNavbar";

import { GeneralSettingsView } from "./GeneralSettingsView";

type Props = {
  viewTitle: ViewNameTranslation;
};

export function GeneralSettingsPage({ viewTitle }: Props) {
  useNavbar({ viewTitle });
  return <GeneralSettingsView />;
}
